import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* ===== Desktop Sidebar ===== */}
      <aside className="admin-sidebar d-none d-md-flex">
        <div className="sidebar-inner">
          <div className="sidebar-header">
            <h4>Admin Panel</h4>
            <small>Management</small>
          </div>

          <ul className="sidebar-menu">
            <Item to="/admin/dashboard" label="Dashboard" icon="📊" active={isActive("/admin/dashboard")} />
            <Item to="/admin/users" label="Users" icon="👥" active={isActive("/admin/users")} />
            <Item to="/admin/videos" label="Videos" icon="🎥" active={isActive("/admin/videos")} />
            <Item to="/admin/tenders" label="Notice Board" icon="📄" active={isActive("/admin/tenders")} />
            <Item to="/admin/gallery" label="Gallery" icon="🖼" active={isActive("/admin/gallery")} />
            <Item to="/admin/complaints" label="Complaints" icon="📝" active={isActive("/admin/complaints")} />
            <Item to="/admin/case-hearing" label="Case Hearing" icon="⚖️" active={isActive("/admin/case-hearing")} />
          </ul>
        </div>
      </aside>
    </>
  );
}

function Item({ to, label, icon, active }) {
  return (
    <li className={`sidebar-item ${active ? "active" : ""}`}>
      <Link to={to} className="sidebar-link">
        <span className="icon">{icon}</span>
        <span>{label}</span>
      </Link>
    </li>
  );
}
